export default __webpack_public_path__ + "static/media/chart.5503900e.svg";